'use strict';
var parent = require('../../stable/instance/slice');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/instance/slice.js
// module id = 537
// module chunks = 13